import gql from "graphql-tag";

export const MY_TAX_CREATE_UNDER_25_DECLARATION = gql`
  mutation createTaxDeclarationUnder25(
    $dateOfDeclaration: Date!
    $noApply: Boolean!
    $discountLimit: Float!
    $noApplyAboveLimit: Boolean!
  ) {
    createTaxDeclarationUnder25(
      dateOfDeclaration: $dateOfDeclaration
      noApply: $noApply
      discountLimit: $discountLimit
      noApplyAboveLimit: $noApplyAboveLimit
    ) {
      result
      messages
      tableId
    }
  }
`;
